import { getPreview } from '../../../pages/api';

const gssp = async ({ params }) => {
  let props = {};
  const getContent = (data) => data?.contents?.find((c) => c.id === Number(params.cid));
  const formatResponse = (message) => {
    let dataResponse = {};

    if (!message || message === undefined) {
      dataResponse = { ...dataResponse, data: {}, code: 'error' };
    } else if (Object.prototype.hasOwnProperty.call(message, 'data')) {
      dataResponse = getContent(message.data)?.modules
        ? ({ ...dataResponse, data: message.data, code: 'ok' })
        : ({ ...dataResponse, data: message.data, code: 'error' });
    } else {
      dataResponse = { ...dataResponse, data: {}, code: 'error' };
    }

    return dataResponse;
  };

  let preview;
  if (params.cid) {
    preview = await getPreview({ id: params.pid, cid: params.cid });
  } else {
    preview = await getPreview({ id: params.pid });
  }
  const previewData = formatResponse(preview);

  if (previewData.code === 'error') {
    return {
      notFound: true
    };
  }

  if (previewData.code === 'ok') {
    const content = getContent(previewData.data);
    props = {
      ...props,
      page: previewData.data,
      modules: content?.modules
    };

    // add storyPage prop to render article logic if preview page is a story
    if (props.page.type === 'story') props = { ...props, storyPage: true };
    if (props.page.type === 'page') props = { ...props, cmsPage: true };

    // find le scoop module in modules to return featured stories Ids
    // eslint-disable-next-line no-underscore-dangle
    const [leScoopMod] = props.modules?.filter?.((mod) => mod.__component === 'modules.le-scoop');
    const le_scoop = leScoopMod || {};
    const featuredStoriesIds = Object.values(le_scoop.elements ?? {})
      .map((story) => story.story_id);

    return {
      ...props,
      featuredStoriesIds
    };
  }

  return {
    notFound: true
  };
};

export default gssp;
